export default "__VITE_ASSET__BHIYsmRM__"